var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-button"},[_c('el-button',{style:(_vm.style),on:{"click":_vm.action}},[_c('span',[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('span',[_c('i',{staticClass:"el-icon-arrow-right"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }